import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styles from './strategyInfo.module.scss';
import InstrumentIcon from '../../../../../../components/InstrumentIcon';
import { NumberText } from '../../../../../../components/Texts';

export const StrategyInfo = memo(({ strategy }) => {
  const { strategyDetail, strategySets } = strategy;
  const { instrumentId, serviceId, name } = strategyDetail;
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <InstrumentIcon className={styles.icon} size="small" instrumentId={instrumentId} serviceId={serviceId} />
      </div>
      <div className={styles.strategyText}>{name}</div>
      <NumberText value={strategySets} className={styles.setNumber} symbol="セット" symbolClassName={styles.unitText} />
    </div>
  );
});

StrategyInfo.propTypes = {
  strategy: PropTypes.shape({
    strategyDetail: PropTypes.shape({
      instrumentId: PropTypes.string.isRequired,
      serviceId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    strategySets: PropTypes.number.isRequired,
  }).isRequired,
};
